import React from 'react';
import {createRoot} from 'react-dom/client';

import BaseComponent from '../../common/BaseComponent/BaseComponent';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import ComponentHomePageMainServices
	from '../../components/ComponentHomePageMainServices/ComponentHomePageMainServices';
import './PageHome.scss';
import ComponentTestimonials from "../../components/ComponentTestimonials/ComponentTestimonials";
import ComponentHeaderPublic from "../../components/ComponentHeaderPublic/ComponentHeaderPublic";
import {ContextServicePriceProvider} from '../../context/ContextServicePriceProvider';
import DomainSearch from './DomainSearch/DomainSearch';
import ClientLogos from "../../common/primitives/ClientLogos";

class PageHome extends BaseComponent {

	mainSectionRef = React.createRef();
	testimonials = null;
	whySuperHosting = null;
	blogPosts = null;
	footer = null;
	lang = 'bg'

	constructor() {
		super(...arguments, 'PageHome');
		SHVO.pageComponent = this;
		this.lang = SHVO.pageLang ?? 'bg';
	}

	static isBottom(el) {
		return Math.round(el.getBoundingClientRect().bottom - 150) <= window.innerHeight;
	}

	handleScroll = () => {
		/*НЕ ПРОМЕНЯЙ ПОДРЕДБАТА*/
		if (PageHome.isBottom(this.mainSectionRef.current)) {
			if (!this.whySuperHosting) {
				import(/* webpackChunkName: "/chunks/ComponentHomePageWhySuperHosting" */ '../../components/ComponentHomePageWhySuperHosting/ComponentHomePageWhySuperHosting').then(module => {
					this.whySuperHosting = React.createElement(module.default);
					this.forceUpdate();
				});
			} else if (!this.blogPosts && this.lang === 'bg') {
				import(/* webpackChunkName: "/chunks/ComponentHomePageBlogPosts" */ '../../components/ComponentHomePageBlogPosts/ComponentHomePageBlogPosts').then(module => {
					this.blogPosts = React.createElement(module.default, {data: {}});
					this.forceUpdate();
				});

			} else if (!this.footer) {
				import(/* webpackChunkName: "/chunks/ComponentFooter" */ '../../components/ComponentFooter/ComponentFooter').then(module => {
					this.footer = React.createElement(module.default);
					this.forceUpdate();
				});
			}
		}
	};

	componentDidMount() {
		/* винаги зареждаме началото на страницата*/
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
			window.scrollTo(0, 0);
		}
		super.componentDidMount();
		window.addEventListener('scroll', this.handleScroll);
		document.addEventListener("DOMContentLoaded", this.importChat);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	render() {
		let testimonials = this.context.get('ComponentTestimonials');
		if (!testimonials) {
			testimonials = {};
		}
		return (
		  <div>
			  <ComponentHeaderPublic/>
			  <section role="main" ref={this.mainSectionRef}>
				  <ContextServicePriceProvider>
					  <DomainSearch/>
					  <ComponentHomePageMainServices data={{}}/>
				  </ContextServicePriceProvider>
				  <div>
					  <ClientLogos/>
				  </div>
				  {
					testimonials.componentData &&
					<div>
						<ComponentTestimonials
						  data={testimonials}
						/>
					</div>
				  }
				  {this.whySuperHosting}
				  {this.blogPosts}
				  {this.footer}
			  </section>
		  </div>
		);
	}
}


// React Context binding
PageHome.contextType = ContextDataStore;
const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageHome data={SHVO.pageState} isLazy={'1'}/>);